import React, { useState } from 'react';

export default function QNA () {
    const [activeQNA, handleActiveQNA] = useState('');

    return (
        <div className="page page--qna">
            <div className="container">
                <div className="page-section page-section--qna">
                    <div className="h2">Frequently Asked Questions</div>
                    <div className="page-section__body">
                        {qnaList.map((qna, index) => (
                            <div 
                                key={index}
                                className={activeQNA !== qna.question ? 'qna-el' : 'qna-el qna-el--active'} 
                                onClick={() => activeQNA !== qna.question ? handleActiveQNA(qna.question) : handleActiveQNA('')}
                            >
                                <div className="qna-el__question">
                                    <span>{qna.question}</span>
                                    <svg className="qna-el__question__chevron" width="20px" height="20px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>chevron-down</title><path d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z" /></svg>
                                </div>
                                <div className="qna-el__answer">
                                    <span>{qna.answer}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}

const qnaList = [
    {
        question: "Can I receive a free quote or estimate over the phone?",
        answer: "Yes, we can provide a preliminary estimate. However, please note that additional issues may be identified by our technician upon closer inspection, which could affect the final cost."
    },
    {
        question: "How long will it take to get the job done?",
        answer: "The timeline for completing the task depends on the specific job requirements. Our experienced technicians can provide an estimated timeframe once an on-site assessment is conducted.",
    },
    {
        question: "Why is annual central heating and boiler maintenance necessary?",
        answer: "Regular checks by our technicians ensure optimal performance, energy efficiency, and safety for your heating system and boiler.",
    },
    {
        question: "I have a broken boiler resulting in no hot water or central heating. Can your technicians resolve the issue today?",
        answer: "Yes, it is possible to resolve the issue if you have the necessary part. Our technicians are experienced in identifying and repairing common boiler problems, but in some cases, we may need to order specific parts. Please note that it may take up to 3 days for the necessary parts to arrive."
    },
    {
        question: "How long does it take to install a boiler?",
        answer: "The installation timeframe for a boiler typically takes up to 2 working days, although it may vary depending on factors such as the type of central heating system and other specific requirements. Our experienced technicians can provide a more accurate estimate based on your unique needs."
    },
    {
        question: "I cannot take a day off work. Is it possible for you to come after 17:00?",
        answer: "Yes, we do work after 17:00. Our flexible scheduling options aim to provide convenient solutions for our customers' heating and plumbing needs."
    }
]